import React, { useCallback } from 'react';
import { makeStyles, Link } from '@material-ui/core';
import { useAppState } from '../../../state';
import UserAvatar from './UserAvatar/UserAvatar';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import * as Cookies from 'js-cookie';

const useStyles = makeStyles({
  userContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    margin: '1em',
    display: 'flex',
    alignItems: 'center',
  },
  userButton: {
    color: 'white',
  },
  logoutLink: {
    color: 'white',
    cursor: 'pointer',
    padding: '10px 20px',
  },
});

const UserMenu: React.FC = () => {
  const classes = useStyles();
  const { user, signOut } = useAppState();
  const { localTracks } = useVideoContext();

  const handleSignOut = useCallback(() => {
    localTracks.forEach(track => track.stop());
    signOut?.();
  }, [localTracks, signOut]);

  if (process.env.REACT_APP_SET_AUTH === 'passcode') {
    return (
      <div className={classes.userContainer}>
        <Link onClick={handleSignOut} className={classes.logoutLink}>
          Logout
        </Link>
      </div>
    );
  }

  if (Cookies.get(process.env.REACT_APP_EXPERT_AUTH_COOKIE_NAME as string)) {
    return (
      <div className={classes.userContainer}>
        <UserAvatar user={user} />
      </div>
    );
  }

  return null;
};

export default UserMenu;
